export function objectComparision(oldData: any, newData: any) {
  let sortedData: any = {};
  Object.keys(newData)
    .filter((key) => key !== "profileUrl")
    .forEach((label: string) => {
      if (label === "state" || label === "userGrade") {
        if (newData[label].value !== oldData[label]) {
          sortedData[label] = newData[label].value;
        }
      } else if (label === "educatorGrade") {
        const gradeArray: any[] = newData[label].map(function (item: any) {
          return item["value"];
        });
        if (gradeArray.join(",") !== oldData[label]) {
          sortedData[label] = gradeArray.join(",");
        }
      } else if (
        newData[label] !== undefined &&
        oldData[label] !== undefined &&
        newData[label] !== oldData[label].toString()
      ) {
        sortedData[label] = newData[label];
      }
    });
  return sortedData;
}

export function getArrayData(convetedlist: any[], list: any[]) {
  let filteredArray: any[] = [];
  filteredArray = list.filter((options: any) => {
    return convetedlist.find((option: any) => {
      return option === options.value;
    });
  });
  return filteredArray;
}

export function getValuesOnly(data: any) {
  let valuesArray: any[] = [];
  valuesArray = data.map(function (item: any) {
    return item["value"];
  });
  return valuesArray.join(",");
}

export function getLabelsOnly(data: any) {
  let valuesArray: any[] = [];
  valuesArray = data.map(function (item: any) {
    return item["label"];
  });
  return valuesArray.join(", ");
}

export function objArrayToArrayobjConvertor(object_arrays: any) {
  let final_array = object_arrays[Object.keys(object_arrays)[0]].map(
    (_el: any, i: number) => {
      let internal_object: any = {};
      Object.keys(object_arrays).forEach(
        (key: any) => (internal_object[key] = object_arrays[key][i])
      );
      return internal_object;
    }
  );
  return final_array;
}

export function validateFormData(obj: any) {
  for (var item in obj) {
    if (!obj[item]) {
      return false;
    }
  }
}

export const removeArrEle = (arr: Array<any>, index: number) => {
  return arr.slice(0, index).concat(arr.slice(index + 1));
};

export const formatPhoneNumber = (value: any) => {
  let actual_val = value
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  actual_val = !actual_val[2]
    ? actual_val[1]
    : "(" +
      actual_val[1] +
      ") " +
      actual_val[2] +
      (actual_val[3] ? "-" + actual_val[3] : "");
  return actual_val;
};

export function capitalize(word: string) {
  return word[0].toUpperCase() + word.substring(1).toLowerCase();
}
